import { render, staticRenderFns } from "./domaine-jean-tardy.vue?vue&type=template&id=21063a53&scoped=true"
import script from "./domaine-jean-tardy.vue?vue&type=script&lang=js"
export * from "./domaine-jean-tardy.vue?vue&type=script&lang=js"
import style0 from "./domaine-jean-tardy.vue?vue&type=style&index=0&id=21063a53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21063a53",
  null
  
)

export default component.exports